import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
    selector: 'tt-product-move-choice',
    templateUrl: './product-move-choice.component.html',
    styleUrls: ['./product-move-choice.component.css'],
    standalone: false
})
export class ProductMoveChoiceComponent implements OnInit {
    prodId;

    compKeyno;

    public edit?: Edit;

    public selectListMoveTo: Item[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.prodId = this.stateService.getStateParams()['prod_id'];
        this.compKeyno = this.stateService.getStateParams()['comp_keyno'];
    }

    private async loadEdit() {
        if (!!this.prodId && !!this.compKeyno) {
            this.edit = (await this.datatask.Post(2893, {
                prod_id: this.prodId,
                comp_keyno: this.compKeyno
            }))[0];
        }
    }

    private async loadMoveTo() {
        if (!this.edit) return;

        return this.selectListMoveTo = await this.datatask.Post(2894, this.edit);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2895, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadMoveTo();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    prod_id: string;
    prod_name: string;
    comp_keyno: string;
    choice_prod_id: string;
    choice_prod_name: string;
    move_to_comp_keyno: string;
    move_to_comp_keyno_before: string;
}
